import { createAction, props } from '@ngrx/store';

const SET_KEYWORDS = '[Util] Set Keywords';
const SET_KEYWORDS_META = '[Util] Set Keywords Meta';

export const setKeywords = createAction(
  SET_KEYWORDS,
  props<{ restrictedKeywords: string[]; restrictedSqlKeywords: string[]; restrictedTableKeywords: string[] }>()
);

export const setKeywordsMeta = createAction(
  SET_KEYWORDS_META,
  props<{ keywordsMeta: { etag: string; cacheTime: Date; maxAge: number } }>()
);
